import React, { useContext, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { STATIC_URLS } from "consts";
import { LayoutContext } from "App/common/hoc/Layout";
import { ADD_COMPUTER_STEPS } from "App/componentsConfig";
import {
  downloadClientSetupStart,
  downloadClientMSIStart,
  fetchBackupPlansStart
} from "store/actions";
import { config } from "config";
import AddComputer2 from "./AddComputer2";
import { decryptData } from "utils";
import EditDefaultPlan from "./EditDefaultPlan";

function AddComputer(props) {
  const [page, setPage] = useState(1);
  const [toggle, setToggle] = useState(true);
  const downloadPath =
    config.API_URL +
    (config.APP_INSTANCE === "ibackup" ? "/ibackup" : "") +
    "/static/clientSetup/" +
    (props.origin === "360"
      ? "IDriveMirror_thin"
      : config.APP_INSTANCE === "ibackup"
      ? "IBackupMirror_full"
      : "IDriveMirror_full") +
    "?loginId=" +
    decryptData(localStorage.getItem("mirrorId")) +
    "&token=" +
    localStorage.getItem("token");
  // not using "/mirror/downloads/clientSetup" page
  const msiDownloadPath =
    config.API_URL + "/static/clientMsi?token=" + props.deploymentToken;
  const { lMethods } = useContext(LayoutContext);
  let monthNames = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12"
  };
  const releaseDate =
    props.versionInfo &&
    monthNames[props.versionInfo.releaseDate.split(" ")[1]] +
      "/" +
      props.versionInfo.releaseDate.split(" ")[0] +
      "/" +
      props.versionInfo.releaseDate.split(" ")[2];

  useEffect(() => {
    props.fetchBackupPlansStart();
  }, []);

  function toggleArrow() {
    setToggle(prevState => !prevState);
  }

  function copyCode(url, num) {
    if (navigator.clipboard) navigator.clipboard.writeText(url);
    let copylink = document.getElementsByClassName("copylink")[num]
      .childNodes[0];
    if (copylink) {
      copylink.style.background = "rgb(255, 255, 0)";
      copylink.classList.add("highlighted");
      if (num == 1) copylink.innerHTML = "Configuration ID Copied";
      else copylink.innerHTML = "Link Copied";
      setTimeout(() => {
        copylink.style.background = "rgb(255, 255, 255)";
        copylink.innerHTML = url;
        copylink.classList.remove("highlighted");
      }, 2500);
    }
  }
  return (
    <div
      className={[
        "slider_welcome",
        config.APP_INSTANCE === "ibackup" ? "" : "addcomputer_wrap"
      ].join(" ")}
    >
      {config.APP_INSTANCE === "ibackup" ? (
        <div className="slider_welcome__innner">
          {ADD_COMPUTER_STEPS.steps.map((step, i) => (
            <div
              key={i}
              className={[
                "welcome_item welcome_item_" + (i + 1),
                step.title === "Add Computer" ? "download_wrap" : ""
              ].join(" ")}
            >
              <div className="welcome_item_left">
                <h3 className="main_title">
                  <span>{i + 1}.</span>
                  {step.title}
                </h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof step.content === "object"
                        ? step.content[config.APP_INSTANCE]
                        : step.content
                  }}
                />
              </div>
              <div className="welcome_item_right">
                <div className="icon">{React.createElement(step.icon)}</div>
              </div>
              {step.title === "Add Computer" && (
                <React.Fragment>
                  <div className="flex-rows-break"></div>
                  <div
                    className="dbw_wrap windows_panel"
                    style={{ display: "block" }}
                  >
                    <div className="dbw_inner">
                      <p className="dw_title">
                        {config.APP_INSTANCE === "ibackup" ? (
                          <React.Fragment>
                            Download IBackup<sup>®</sup> Mirror
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            Download IDrive<sup>®</sup> Mirror
                          </React.Fragment>
                        )}{" "}
                      </p>
                      <div className="dbw_box">
                        <div className="db_box_left">
                          {" "}
                          <div
                            className="tab_btn"
                            onClick={
                              !props.downaloadingClient
                                ? () =>
                                    props.downloadClientSetupStart(
                                      config.APP_INSTANCE === "ibackup"
                                        ? "ibackup"
                                        : null,
                                      props.origin
                                    )
                                : () => {}
                            }
                          >
                            {props.downaloadingClient ? (
                              <p
                                className="pass_loader"
                                style={{ display: "block" }}
                              >
                                <img
                                  src={
                                    process.env.REACT_APP_STATIC_URL +
                                    "/images/submit_loader.gif"
                                  }
                                  alt="loader"
                                />
                              </p>
                            ) : (
                              <i className="icon2" />
                            )}
                            {props.downaloadingClient ? "" : "Windows"}
                          </div>{" "}
                        </div>
                        <div className="db_box_right">
                          <div className="dbr">
                            <p className="db_version">
                              {" "}
                              Version:{" "}
                              {props.versionInfo && props.versionInfo.versionNo}
                            </p>
                            <p className="db_released">
                              {" "}
                              Released on: {releaseDate}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="copylink">
                      <b style={{ background: "rgb(255, 255, 255)" }}>
                        {downloadPath}
                      </b>
                      <button
                        className="copy_btn"
                        onClick={() => copyCode(downloadPath, 0)}
                      >
                        Copy Link
                      </button>
                    </div>
                  </div>
                  <div className="sys_requirement">
                    <a
                      href="javascript:;"
                      onClick={() =>
                        lMethods.openPopup("systemRequirements", {})
                      }
                    >
                      <span />
                      System Requirements
                    </a>
                  </div>
                </React.Fragment>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="slider_welcome__innner id-plan-bkp">
          {page === 1 ? (
            <div className="addcomputer_blk1">
              {[ADD_COMPUTER_STEPS.steps[0]].map((step, i) => (
                <div
                  key={i}
                  className={[
                    "welcome_item welcome_item_" + (i + 1),
                    step.title === "Add Computer" ? "download_wrap" : ""
                  ].join(" ")}
                >
                  <div className="welcome_box">
                    <div className="welcome_item_left">
                      <h3 className="main_title">
                        {/* <span>{i + 1}.</span> */}
                        {step.title}
                      </h3>
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            typeof step.content === "object"
                              ? props.origin === "360"
                                ? step.content["mirror360"]
                                : step.content[config.APP_INSTANCE]
                              : step.content
                        }}
                      />
                    </div>

                    <div className="welcome_item_right">
                      <div className="icon comp_ico">
                        {React.createElement(step.newIcon)}
                      </div>
                    </div>
                  </div>
                  {step.title === "Add Computer" && (
                    <React.Fragment>
                      <div className="flex-rows-break"></div>
                      <div
                        className="dbw_wrap windows_panel"
                        style={{ display: "block" }}
                      >
                        <div className="dbw_inner">
                          <p className="dw_title">
                            {config.APP_INSTANCE === "ibackup" ? (
                              <React.Fragment>
                                Download IBackup<sup>®</sup> Mirror
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                Download IDrive<sup>®</sup> Mirror
                              </React.Fragment>
                            )}{" "}
                          </p>
                          <div className="dbw_box">
                            <div className="db_box_left">
                              {" "}
                              <div
                                className="tab_btn"
                                onClick={
                                  !props.downaloadingClient
                                    ? () => {
                                        props.downloadClientSetupStart(
                                          config.APP_INSTANCE === "ibackup"
                                            ? "ibackup"
                                            : null,
                                          props.origin
                                        );
                                        setTimeout(() => setPage(2), 1000);
                                      }
                                    : () => {}
                                }
                              >
                                {props.downaloadingClient ? (
                                  <p
                                    className="pass_loader"
                                    style={{ display: "block" }}
                                  >
                                    <img
                                      src={
                                        process.env.REACT_APP_STATIC_URL +
                                        "/images/submit_loader.gif"
                                      }
                                      alt="loader"
                                    />
                                  </p>
                                ) : (
                                  <i className="icon2" />
                                )}
                                {props.downaloadingClient ? "" : "Windows"}
                              </div>{" "}
                            </div>
                            <div className="db_box_right">
                              <div className="dbr">
                                <p className="db_version">
                                  {" "}
                                  Version:{" "}
                                  {props.versionInfo &&
                                    props.versionInfo.versionNo}
                                </p>
                                <p className="db_released">
                                  {" "}
                                  Released on: {releaseDate}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="copylink">
                          <b>{downloadPath}</b>
                          <button
                            className="copy_btn"
                            onClick={() => copyCode(downloadPath, 0)}
                          >
                            Copy Link
                          </button>
                        </div>
                      </div>
                      <div className="sys_requirement">
                        <a
                          href="javascript:;"
                          onClick={() =>
                            lMethods.openPopup("systemRequirements", {})
                          }
                        >
                          <span />
                          System Requirements
                        </a>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              ))}
              {config.APP_INSTANCE !== "ibackup" && (
                <div className="welcome_item welcome_item_2 grp_deployCtnr">
                  <h3 className="main_title" onClick={() => toggleArrow()}>
                    Group deployment via MSI
                    <a
                      href="javascript:;"
                      className={["toggle_grp", toggle ? "active" : ""].join(
                        " "
                      )}
                    />
                  </h3>
                  {toggle && (
                    <div className="grp_deployBlk">
                      <p>
                        Copy the Configuration ID and run it along with the MSI
                        command for mass deployment{" "}
                        <a
                          href={
                            STATIC_URLS.massDeploy[
                              props?.origin === "idrive" ? "idrive" : "mirror"
                            ]
                          }
                          className="more_link"
                          target="_blank"
                        >
                          Know More &gt;
                        </a>{" "}
                      </p>
                      <div className="deployBlk configID">
                        <h4>Configuration ID</h4>
                        <div className="copylink">
                          <b>
                            {props.deploymentToken && props.deploymentToken}
                          </b>
                          <button
                            className="copy_btn"
                            onClick={() => copyCode(props.deploymentToken, 1)}
                          >
                            Copy
                          </button>
                        </div>
                        <input
                          type="submit"
                          className="common_btn btn_primary"
                          value="Download MSI"
                          onClick={
                            !props.downloadingMSI
                              ? () => props.downloadClientMSIStart()
                              : () => {}
                          }
                        />
                      </div>
                      <div className="deployBlk installLink">
                        <h4>Installation link for MSI package</h4>
                        <div className="copylink">
                          <b>{msiDownloadPath}</b>
                          <button
                            className="copy_btn"
                            onClick={() => copyCode(msiDownloadPath, 2)}
                          >
                            Copy Link
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <>
                <EditDefaultPlan />
              </>
            </div>
          ) : (
            <AddComputer2
              setPage={setPage}
              downloadClientSetupStart={props.downloadClientSetupStart}
            />
          )}
        </div>
      )}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    versionInfo: state.dashboard.versionInfo,
    deploymentToken: state.dashboard.deploymentToken,
    downaloadingClient: state.dashboard.downaloadingClient,
    downloadingMSI: state.dashboard.downloadingMSI,
    ecommerceFlag: state.account.ecommerceFlag,
    origin: state.account.origin
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      downloadClientSetupStart,
      downloadClientMSIStart,
      fetchBackupPlansStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AddComputer);
